import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Close from '../../icons/Close';
import Typography from '../Typography';
import BodyScrollLock from '../../helpers/bodyScrollLock';
import SlideTransition from '../Transitions/SlideTransition';
import FadeTransition from '../Transitions/FadeTransition';

const ModalDiv = styled.div`
  z-index: 15;
`;

const LayoutDiv = styled.div`
  background: rgba(0, 0, 0, 0.75);
  z-index: 8;
`;
const Div = styled.div`
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 1);
  background: #fff;
  max-height: 92vh;
  border-radius: 10px 10px 0 0;
  width: 100%;
  z-index: 9;
  bottom: 0;
  overflow-y: auto;
  ${({ full }) =>
    full &&
    css`
      max-height: 100vh;
      height: 100%;
      border-radius: 0;
    `}
  @media screen and (min-width: 768px) {
    max-height: inherit;
    border-radius: 10px;
    bottom: initial;
    margin: 0;
    height: auto;
    ${({ size }) => {
      switch (size) {
        case 'lg':
          return css`
            max-width: 800px;
          `;
        case 'md':
          return css`
            max-width: 600px;
          `;
        case 'sm':
          return css`
            max-width: 480px;
          `;
        case 'xs':
          return css`
            max-width: 300px;
          `;
      }
    }};
  }
`;
const HeaderDiv = styled.div`
  padding: 24px 24px 15px;
  padding: 24px 24px 15px;
  border-bottom: 1px solid #ddd;
  @media (max-width: 767px) {
    padding: 16px;
  }
`;
const CloseIcon = styled(Close)`
  width: 20px;
  height: 20px;
`;
const Ptag = styled(Typography)`
  margin: 0 0 0 30px;
  color: ${({ theme }) => theme.colors.TextAlpha};
  @media (max-width: 767px) {
    margin: 0 0 0 14px;
  }
`;
const BodyDiv = styled.div`
  padding: 24px;
  max-height: calc(92vh - 48px);
  ${({ className }) => {
    switch (className) {
      case 'no-padding':
        return css`
          padding: 0;
        `;
    }
  }}
  @media (max-width: 767px) {
    ${({ withHeader }) =>
      withHeader
        ? css`
            padding: 16px;
          `
        : css`
            padding: 0;
          `}
    max-height: 100%;
    overflow: auto;
  }
`;

const Sub = styled.span`
  margin-left: auto;
`;

const Modal = ({
  onClose,
  show,
  slideFrom,
  size,
  children,
  title,
  subTitle,
  className,
  withHeader,
  full,
  ...rest
}) => {
  return (
    <ModalDiv className="pF l0 t0 w100 h100 dFA jcC peN">
      {show && <BodyScrollLock />}
      <SlideTransition duration={400} in={show} appear unmountOnExit slideFrom={slideFrom}>
        <Div className={`pA dF fdC peA ${className || ''}`} size={size} full={full} {...rest}>
          {withHeader && (
            <HeaderDiv className="dFA">
              <span className="dF cP" role="button">
                <CloseIcon onClick={onClose} />
              </span>
              {title && (
                <Ptag tagName="p" modifiers={['bold', 'h3']} className="pR Ell">
                  {title}
                </Ptag>
              )}
              {subTitle && <Sub>{subTitle}</Sub>}
            </HeaderDiv>
          )}
          <BodyDiv withHeader={withHeader} className="bodyDiv oA">
            {children}
          </BodyDiv>
        </Div>
      </SlideTransition>
      <FadeTransition in={show} duration={300} appear>
        <LayoutDiv className="pF l0 t0 w100 h100 peA" onClick={onClose} />
      </FadeTransition>
    </ModalDiv>
  );
};
Modal.propTypes = {
  size: PropTypes.oneOf(['lg', 'md', 'sm', 'xs']),
  children: PropTypes.any,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.node,
  className: PropTypes.string,
  full: PropTypes.bool,
  withHeader: PropTypes.bool,
  slideFrom: PropTypes.string
};

Modal.defaultProps = {
  size: 'md',
  full: false,
  withHeader: true,
  slideFrom: 'bottom'
};
export default Modal;
